import { render } from "./ProjectForm.vue?vue&type=template&id=5671b750&scoped=true&ts=true"
import script from "./ProjectForm.ts?vue&type=script&lang=ts"
export * from "./ProjectForm.ts?vue&type=script&lang=ts"

import "./ProjectForm.scss?vue&type=style&index=0&id=5671b750&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5671b750"]])

export default __exports__